<!--  -->
<template>
  <div>
    <el-input v-model="input" placeholder="请输入金额" type="number" min="1" style="width:200px" @blur="inputw" />
    <div style="margin-top:30px">
      <el-button type="primary" size="mini" @click="sewrw">确定</el-button>
    </div>

  </div>
</template>

<script>
import { getqrcode } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      input: '',
      id: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    sendr(item) {
      console.log('item', item)
      this.id = item.openId
    },
    async sewrw() {
      if (this.input === '') {
        this.$message.error('请输入金额')
        return
      }
      const data = await getqrcode({
        open_id: this.id,
        total_amount: this.input
      })
      this.$message({
        message: '生成成功',
        type: 'success'
      })
      this.$emit('callback', data.data.path)
      console.log('data', data.data.path)
    },
    inputw() {
      if (this.input <= 0) {
        this.input = 1
      }
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
